import { type RootState, useAppSelector } from '@/app/store'
import useUrlQueryParams from '@/hooks/use-url-query-params'

/**
 * Reads state from Redux store and fallback to query params if not found
 */
const useTieredSelector = <S, T, V = undefined>(
  reduxSelector: (state: RootState) => S | null,
  queryParamSelector?: (params: T) => V | undefined,
): S | V | undefined => {
  const { getQueryParams } = useUrlQueryParams<T>()
  const reduxValue = useAppSelector(reduxSelector)
  return reduxValue ?? queryParamSelector?.(getQueryParams())
}

// biome-ignore lint/style/noDefaultExport: Existing default export — prefer named exports for new code
export default useTieredSelector
